<template>
    <div >
      
        
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default{
        data(){
            return{
                loading:false,
            }
        },
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        computed:{
            headerScript:{
                get(){
                    if(this.detail_event.script_header){
                        return atob(this.detail_event.script_header)
                    }else{
                        return this.detail_event.script_header
                    }
                },
                set(value){
                    this.detail_event.script_header = btoa(value)
                }
                
            },
            footerScript:{
                get(){
                    if(this.detail_event.script_footer){
                        return atob(this.detail_event.script_footer)
                    }else{
                        return this.detail_event.script_footer
                    }
                },
                set(value){
                    this.detail_event.script_footer = btoa(value)
                }
            },
        },    
        methods:{
            ...mapActions('EventsControl', ['detailEvents','updateBasicSetup','changeWording']),
            
            validationForm: function(type) {
                this.loading = true

                var formData = new FormData();

                formData.append("_method", "put");
                formData.append("type", type);
               

                this.updateBasicSetup(formData).then(() => {
                    this.loading = false
                    this.detailEvents(this.$route.params.id)
                    this.$toast.success('Successfully Update Event')
                }) 

            },
            
        }
    }

</script>